import ShoppingCart from "../../../components/shopping-cart/ShoppingCart";
import Auth from "../../../libs/API/Auth";
import Payments from "../../../libs/API/Payments";
import moment from "moment";

class CampaignPlanningConfirmationModalContract {
  constructor() {
    this.main = document.getElementById('checkout_modal_contract');

    this._btnClose = this.main.querySelector('.btn_close_contract');
    this._contractWrapper = this.main.querySelector('.contract-wrapper');
    this._contractBtnContinue = this.main.querySelector('.btn_continue_contract');
    this._downloadPdfBtn = this.main.querySelector('.btn_download_pdf');

    this._contractWrapper.addEventListener('scroll', this._onScrollContract.bind(this));
    this._downloadPdfBtn.addEventListener('click', this._onClickDonwloadPdf.bind(this));
    this._contractBtnContinue.addEventListener('click', ()=>{
      this.hide();
      this.main.dispatchEvent(new CustomEvent('PAYMENT_FUNNEL'));
    });
    this._btnClose.addEventListener('click', this._onClickClose.bind(this));
  }

  set setContract(html){
    if(html){
      this._contractWrapper.innerHTML = `${html}`;
    }
  }

  _onClickClose(e) {
    e.preventDefault();
    this.hide();
  }

  _onScrollContract(){
    const scrollTop = this._contractWrapper.scrollTop;
    const scrollHeight = this._contractWrapper.scrollHeight;
    const clientHeight = this._contractWrapper.clientHeight;
    if (scrollTop + clientHeight >= (scrollHeight - 50)) {
      this._contractBtnContinue.classList.remove('button--disabled');
    }
  }

  addEventListener(event, callback) {
    this.main.addEventListener(event, callback);
  }

  show() {
    this.main.classList.add('modal--show');
    document.body.classList.add('block-scroll');
    setTimeout(() => {
      this.main.classList.add('modal--anim');
    }, 50);
  }

  hide() {
    this.loading = false;
    this.main.classList.remove('modal--anim');
    setTimeout(()=>{
      this.main.classList.remove('modal--show');
      document.body.classList.remove('block-scroll');
    }, 750);
  }

  _onClickBtnClose(e) {
    e.preventDefault();
    this.hide();
  }

  _onClickDonwloadPdf(e) {
    e.preventDefault();
    this._downloadPdfBtn.classList.add('link--loading');
    const params = {
        'with_css': true,
        'customer_name': Auth.user.full_name,
        'brand_name': ShoppingCart.data.brand.name,
        'crm_opportunity_id': '',
        'from_date': moment(ShoppingCart.fromDate).format('MM/DD/YY'),
        'to_date': moment(ShoppingCart.toDate).format('MM/DD/YY'),
        'price': ShoppingCart.getTotalCartNumber,
        'billboards': ShoppingCart.data.items.map((item) => {
            return {
                id: item.id,
                name: item.name,
                location_name: item.location.name,
                format_name: item.format.name,
                from_date: moment(item.dateRange.from).format('MM/DD/YY'),
                to_date: moment(item.dateRange.to).format('MM/DD/YY'),
                price: item.price,
                period_length: item.days_available,
                frequency: 'daily',
                spot_type: 'guarantee',
                space_exposure: 100
            }
        }),
    }

    Payments.downloadAgreementPdf(params)
    .then(blob => {
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
        this._downloadPdfBtn.classList.remove('link--loading');
    })
    .catch(error => {
        console.log(error);
        this._downloadPdfBtn.classList.remove('link--loading');
    });
  }

}

export default CampaignPlanningConfirmationModalContract;